import { StrictMode } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import "./utils/AppInsights";

import HttpClient, { RejectWith } from "./api/HttpClient";
import Routes from "./routes/Routes";

import "react-bootstrap-typeahead/css/Typeahead.css";
import "./css/Site.css";
import "@bokinfo/bokinfo-ui/dist/css/bokinfo/main.min.css";
import "react-datepicker/dist/react-datepicker.css";

HttpClient.setRejectWith(RejectWith.object);

ReactDOM.render(
  <StrictMode>
    <BrowserRouter>{Routes}</BrowserRouter>
  </StrictMode>,
  document.querySelector("#root")
);
